import React from 'react';
import styled from 'styled-components';

import Picture1 from '../../../../containers/assets/instructor-onboarding-image6.png';
import Picture2 from '../../../../containers/assets/instructor-onboarding-image7.png';
import Picture3 from '../../../../containers/assets/instructor-onboarding-image8.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: rgba(0, 27, 59, 0.94);
  }
`;

const Images = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 12px;
`;

const WelcomeStep4 = () => (
  <Wrapper>
    <Container>
      <Text1>Welcome</Text1>
      <Text2>Learning Objectives</Text2>
      <Text3>
        This group project will:<br />
        <b>Build Business Basics:</b> help your students experience how the core functions of a business work
        together to achieve business goals.<br />
        <b>Build Career Ready Skills:</b> help your students foster critical thinking and teamwork skills.<br />
        <b>Build Community:</b> help cultivate relationships with other students in their course.
      </Text3>

      <Images>
        <img src={Picture1} alt="" />
        <img src={Picture2} alt="" />
        <img src={Picture3} alt="" />
      </Images>

      <Text3>
        Let's now walk through how the game works!
      </Text3>
    </Container>
  </Wrapper>
);

export default WelcomeStep4;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/welcome/step4.js